<template>
  <div class="container-fluid px-4 py-4 legal-page">

    <!-- Header estilo panel -->
    <div class="legal-header mb-4">
      <button class="btn-volver mb-3" @click="$router.back()">
        <i class="fas fa-arrow-left"></i> Volver
      </button>
      <div class="d-flex flex-column flex-lg-row justify-content-between align-items-start gap-3">
        <div>
          <h4 class="mb-1">Política de Privacidad</h4>
          <p class="mb-0 text-muted">
            Información sobre el tratamiento de datos personales conforme al RGPD y la LOPDGDD.
          </p>
        </div>

        <div class="legal-meta">
          <div class="meta-title">Última actualización</div>
          <div class="meta-value">{{ lastUpdate }}</div>
        </div>
      </div>
    </div>

    <!-- Card principal -->
    <div class="card legal-card">
      <div class="card-body">

        <div class="soft-note mb-4">
          <b>Resumen:</b> tratamos únicamente los datos necesarios para gestionar solicitudes, prestar el servicio y mantener la seguridad.
          No enviamos comunicaciones comerciales sin tu consentimiento.
        </div>

        <p class="text-muted mb-3">
          En cumplimiento del Reglamento (UE) 2016/679 (RGPD) y la Ley Orgánica 3/2018 (LOPDGDD),
          se informa al usuario sobre el tratamiento de datos personales realizado en este sitio web.
        </p>

        <!-- Bloque superior (solo títulos: Titular / NIF / Domicilio) -->
        <div class="legal-mini mb-4">
          <div class="mini-grid">
            <div class="mini-item">
              <div class="mini-label">Titular</div>
              <div class="mini-value">XESPORT GALICIA S.L.</div>
            </div>

            <div class="mini-item">
              <div class="mini-label">NIF</div>
              <div class="mini-value">B27777887</div>
            </div>

            <div class="mini-item">
              <div class="mini-label">Domicilio</div>
              <div class="mini-value">CC/ LOPEZ mora n71 5A 36211 Vigo (Pontevedra), Galicia, España.</div>
            </div>
          </div>

          <hr class="mini-sep" />

          <div class="mini-extra">
            <p class="mb-2">
              <b>Contacto:</b> soporte@payoned.com
              <span class="mx-2">•</span>
              <b>Servicio:</b> Quanty
            </p>

            <p class="mb-0 text-muted small">
              Si quieres conocer condiciones de uso, consulta el
              <router-link to="/aviso-legal">Aviso Legal</router-link>.
              Para información sobre cookies y preferencias, consulta la
              <router-link to="/politica-cookies">Política de Cookies</router-link>.
            </p>
          </div>
        </div>

        <h5 class="mt-4">1. Responsable del tratamiento</h5>
        <p>
          El responsable del tratamiento de los datos personales recogidos a través de este sitio web es
          <b>XESPORT GALICIA S.L.</b>, con NIF <b>B27777887</b>.
          Para cualquier consulta o solicitud relativa a privacidad, puedes contactar en <b>soporte@payoned.com</b>.
        </p>

        <h5 class="mt-4">2. Datos que recopilamos</h5>
        <p class="mb-2">
          Dependiendo del uso del sitio, podemos tratar las siguientes categorías de datos:
        </p>
        <ul class="mb-4">
          <li><b>Datos identificativos y de contacto:</b> nombre, apellidos, email, teléfono (si se facilita).</li>
          <li><b>Contenido de comunicaciones:</b> información que el usuario incluya voluntariamente en mensajes o formularios.</li>
          <li><b>Datos técnicos y de uso:</b> IP, navegador, dispositivo, fecha/hora, páginas visitadas (principalmente por seguridad y funcionamiento).</li>
        </ul>
        <h5 class="mt-4">3. Edad mínima</h5>
        <p class="mb-4">
          El acceso y uso de este sitio web está reservado a personas mayores de 18 años.
          El titular no recopila deliberadamente datos personales de menores.
          Si se detectara que se han recopilado datos de un menor sin autorización válida, se procederá a su supresión.
        </p>

        <h5 class="mt-4">4. Finalidades del tratamiento</h5>
        <ul class="mb-4">
          <li>Gestionar consultas y solicitudes de contacto.</li>
          <li>Prestar los servicios solicitados y gestionar la relación con el usuario.</li>
          <li>Gestionar aspectos administrativos/contractuales cuando proceda.</li>
          <li>Mejorar la experiencia del sitio y garantizar la seguridad (prevención de fraude y abusos).</li>
          <li>Enviar comunicaciones comerciales <b>solo si el usuario lo consiente</b> o cuando exista base legal.</li>
        </ul>

        <h5 class="mt-4">5. Base jurídica (legitimación)</h5>
        <ul class="mb-4">
          <li><b>Consentimiento</b> del usuario (art. 6.1.a RGPD) en formularios y comunicaciones voluntarias.</li>
          <li><b>Medidas precontractuales/contrato</b> (art. 6.1.b RGPD) cuando sea necesario para prestar el servicio.</li>
          <li><b>Obligación legal</b> (art. 6.1.c RGPD) cuando proceda (p. ej., normativa fiscal/contable).</li>
          <li><b>Interés legítimo</b> (art. 6.1.f RGPD) para seguridad, prevención de fraude y mejora básica del servicio.</li>
        </ul>

        <h5 class="mt-4">6. Destinatarios y encargados del tratamiento</h5>
        <p class="mb-2">
          Los datos podrán ser tratados por proveedores tecnológicos necesarios para el funcionamiento del servicio, por ejemplo:
          hosting, mantenimiento, herramientas de comunicación o correo. Estos proveedores actuarán como <b>encargados del tratamiento</b>
          bajo contrato conforme al art. 28 RGPD.
        </p>
        <p class="mb-4">
          Asimismo, los datos podrán comunicarse a Administraciones Públicas o autoridades competentes cuando exista obligación legal.
        </p>

        <h5 class="mt-4">7. Transferencias internacionales</h5>
        <p class="mb-4">
          En caso de utilizar proveedores con servidores ubicados fuera del Espacio Económico Europeo, podrán realizarse transferencias
          internacionales de datos. En dichos casos, se aplicarán garantías adecuadas conforme al RGPD (por ejemplo, cláusulas contractuales tipo
          u otros mecanismos válidos).
        </p>

        <h5 class="mt-4">8. Plazos de conservación</h5>
        <p class="mb-4">
          Conservaremos los datos durante el tiempo necesario para cumplir la finalidad para la que fueron recogidos y, posteriormente,
          durante los plazos legalmente exigibles. Cuando el tratamiento se base en el consentimiento, el usuario podrá retirarlo en cualquier momento,
          sin que ello afecte a la licitud del tratamiento previo.
        </p>

        <h5 class="mt-4">9. Derechos del usuario</h5>
        <p class="mb-2">
          El usuario puede ejercer los derechos de acceso, rectificación, supresión, limitación, oposición y portabilidad escribiendo a
          <b>soporte@payoned.com</b>.
        </p>
        <p class="mb-4">
          Si consideras que el tratamiento no se ajusta a la normativa, puedes presentar una reclamación ante la Agencia Española de Protección
          de Datos (AEPD).
        </p>

        <h5 class="mt-4">10. Medidas de seguridad</h5>
        <p class="mb-4">
          Aplicamos medidas técnicas y organizativas razonables para proteger los datos personales frente a pérdida, acceso no autorizado,
          alteración o divulgación. No obstante, ningún sistema es 100% inexpugnable (ni siquiera el "modo empirulado"), así que también
          hacemos revisiones y mejoras periódicas.
        </p>

        <h5 class="mt-4">11. Modificaciones</h5>
        <p class="mb-0">
          El titular podrá modificar esta política para adaptarla a cambios normativos o a criterios de autoridades competentes.
          Se recomienda revisarla periódicamente.
        </p>

      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "PoliticaPrivacidad",
  beforeMount() {
    this.$store.commit('setShowSidenav', false);
    this.$store.commit('setShowNavbar', true);
    this.$store.commit('setShowFooter', true);
  },
  data() {
    return {
      // Puedes mover esto a .env si quieres: VUE_APP_PRIVACY_LAST_UPDATE
      lastUpdate: process.env.VUE_APP_PRIVACY_LAST_UPDATE || new Date().toLocaleDateString("es-ES"),
    };
  },
};
</script>

<style scoped>
.legal-card{
  border-radius: 14px;
  box-shadow: 0 10px 30px rgba(0,0,0,.06);
  border: 1px solid var(--q-border);
}

.legal-header{
  background: var(--q-card-alt);
  border: 1px solid var(--q-border);
  border-radius: 14px;
  padding: 16px 18px;
}

.legal-meta{
  background: var(--q-card-alt);
  border: 1px solid var(--q-border);
  border-radius: 12px;
  padding: 10px 12px;
  min-width: 220px;
}

.meta-title{ font-size: .75rem; opacity: .75; }
.meta-value{ font-weight: 800; }

.soft-note{
  border-radius: 12px;
  padding: 12px 14px;
  background: var(--q-hover);
  border: 1px solid var(--q-border);
}

/* mini ficha titular */
.legal-mini{
  border-radius: 14px;
  padding: 14px 14px;
  border: 1px solid var(--q-border);
  background: var(--q-card-alt);
}

.mini-grid{
  display:grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.mini-item{
  background: var(--q-card);
  border: 1px solid var(--q-border);
  border-radius: 12px;
  padding: 10px 12px;
}

.mini-label{
  font-size: .75rem;
  opacity: .7;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .03em;
}

.mini-value{
  font-weight: 800;
  margin-top: 2px;
  word-break: break-word;
}

.mini-sep{
  margin: 12px 0;
  border: 0;
  border-top: 1px solid var(--q-border);
}

.mini-extra{
  padding: 0 2px;
}

@media (max-width: 992px){
  .mini-grid{ grid-template-columns: 1fr; }
}

.btn-volver {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: 1px solid var(--q-border-md);
  color: var(--q-muted);
  border-radius: 8px;
  padding: 6px 14px;
  font-size: .85rem;
  cursor: pointer;
  transition: color .15s, border-color .15s;
}
.btn-volver:hover { color: var(--q-text); border-color: var(--q-gold); }
</style>
